/** @format */
import { Market } from '@toucan/client/global/market';

import { getProductSKUQuery } from '../helpers';
import { getSearchResults } from '../requests';
import {
    FilterQuery,
    Query,
    SearchListingModel,
    SearchListingProduct,
    SelectedFilters,
    SortBy,
} from '../types';
import {
    getModelListingQuery,
    getModelSearchResultsFacetsQuery,
} from './queries';

export async function getSKUForResult(
    baseQuery: Partial<Query>,
    activeMarket: Market,
    outOfStock: boolean
) {
    const productSKUQuery = getProductSKUQuery(
        baseQuery,
        activeMarket.code,
        outOfStock
    );

    const searchResponse = await getSearchResults<SearchListingProduct>(
        productSKUQuery,
        activeMarket.iso,
        activeMarket.code
    );

    return searchResponse.results[0].productSku;
}

export async function fetchModelSearchResults(
    baseQuery: Partial<Query>,
    filterQuery: FilterQuery,
    sortBy: SortBy,
    start: number,
    rows: number,
    activeMarket: Market,
    outOfStock: boolean
) {
    const modelListingQuery = getModelListingQuery(
        baseQuery,
        start,
        rows,
        filterQuery,
        sortBy,
        activeMarket.code,
        [],
        outOfStock
    );

    const searchResponse = await getSearchResults<SearchListingModel>(
        modelListingQuery,
        activeMarket.iso,
        activeMarket.code
    );

    if (!searchResponse) {
        return {
            results: [],
            resultCount: 0,
            totalResults: 0,
            spellcheck: {
                suggestions: [],
            },
            facets: [],
        };
    }

    return searchResponse;
}

export async function getModelSearchResultsFacets(
    baseQuery: Partial<Query>,
    disallowedFilters: string[],
    sort: SortBy,
    activeMarket: Market,
    selectedFilters: SelectedFilters,
    outOfStock: boolean
) {
    const query = getModelSearchResultsFacetsQuery(
        baseQuery,
        disallowedFilters,
        selectedFilters,
        sort,
        activeMarket,
        outOfStock
    );

    const { facets } = await getSearchResults(
        query,
        activeMarket.iso,
        activeMarket.code
    );

    return facets;
}
